import React from "react";
import ReactDOM from "react-dom";

import "./styles/styles.css";
import "./styles/styles.scss";
import "bootstrap-icons/font/bootstrap-icons.css";

import Routing from "./router/Routing";

ReactDOM.render(
  <React.StrictMode>
    <Routing />
  </React.StrictMode>,
  document.getElementById("root")
);
